
import { makeRequest } from 'utils/requestLogger';

export default (roundtable_id, payload) =>
    makeRequest(
        'post',
        `/api/roundtables/${roundtable_id}/grade-classroom-students`, payload
    );



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/gradeClassroomStudents.js